import {
	endpointsMap,
	IGetSuggestionsOptions,
	IGetSuggestionsResponse
} from './ICustomShopperAddress';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperAddress
 */
class CustomShopperAddress extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets Address suggestions
	 * @param {IGetSuggestionsOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetSuggestionsResponse} - Array of suggestions
	 */
	public async getSuggestions(fetchOptions: IGetSuggestionsOptions, throwOnError?: boolean): Promise<IGetSuggestionsResponse> {
		const response: IGetSuggestionsResponse = await this.callCustomEndpoint<IGetSuggestionsResponse>(
			fetchOptions,
			endpointsMap.GET_SUGGESTIONS
		);

		if (throwOnError && !response.addressSuggestions) {
			throw new Error('Address API Error');
		}

		return response;
	}
}

export default CustomShopperAddress;
